import { describeNotification, parseNotificationData } from './notificationKinds';

/**
 * Куда ведёт нажатие на пуш (договор `docs/CONTRACTS/push.md` §6).
 *
 * ⚠️ ВТОРОЙ ТАБЛИЦЫ ПЕРЕХОДОВ НЕТ. Пуш и строка ленты — одно и то же уведомление, и адрес у них обязан
 * совпадать: здесь данные пуша приводятся к виду строки ленты и отдаются той же `describeNotification`.
 * Новый вид уведомления заводится в `notificationKinds.ts` — и нажатие на пуш узнаёт о нём само.
 *
 * Модуль без плагина и без сети: его проверяют обычные проверки (`pushRoute.test.ts`).
 */

/** Лента уведомлений ученика — для пуша незнакомого вида или вовсе без вида. */
export const PUSH_FALLBACK = '/app/notifications';

/** Адрес экрана по данным пуша. Всегда внутри `/app` — куратору пушей нет. */
export function pushTarget(raw: unknown): string {
  const data = parseNotificationData(raw) ?? {};
  const type = typeof data.type === 'string' ? data.type : '';
  const view = describeNotification(
    { id: '', user_id: '', type, title: '', body: '', data, is_read: false, created_at: '' },
    'student',
  );
  return view.to ?? PUSH_FALLBACK;
}

/** Id строки ленты того же уведомления — чтобы после перехода снять с неё «новое». */
export function pushNotificationId(raw: unknown): string | undefined {
  const id = parseNotificationData(raw)?.notification_id;
  return typeof id === 'string' && id.trim() ? id : undefined;
}
